// Image loader Module
const imageLoader = require(MODULES_PATH + '/image-loader');
new imageLoader();

// Cookie Consent Module
const cookieConsent = require(MODULES_PATH + '/cookie-consent');
new cookieConsent({
  buttonSelector: '.cookie-consent-banner__button',
  bannerSelector: '.cookie-consent-banner',
});

// Header and Footer Module
const headerFooter = require(MODULES_PATH + '/header-footer');
new headerFooter();

document.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('.group-service-card p').forEach((subheading) => {
    subheading.style.height = '0';
    subheading.style.padding = '0';
  });
});

document.querySelectorAll('.group-service-card').forEach((card) => {
  card.addEventListener('mouseenter', function () {
    const subheading = this.querySelector('p');
    subheading.style.padding = '1rem'; // Adjust padding as necessary
    subheading.style.height = subheading.scrollHeight + 36 + 'px';
  });

  card.addEventListener('mouseleave', function () {
    const subheading = this.querySelector('p');
    subheading.style.padding = '0';
    subheading.style.height = '0';
  });
});

// function adjustZoom() {
//   var zoomLevel = 1;
//   if (window.innerWidth >= 1130 && window.innerWidth <= 1440) {
//     zoomLevel = 0.8;
//   }
//   document.body.style.zoom = zoomLevel;
// }

// // Adjust zoom on page load
// window.onload = adjustZoom;

// // Adjust zoom on window resize
// window.onresize = adjustZoom;

document.addEventListener('DOMContentLoaded', (event) => {
  let mainSiteContent = document.querySelector('main#site-content');
  let links = mainSiteContent.getElementsByTagName('a');
  let currentDomain = window.location.hostname;

  for (let i = 0; i < links.length; i++) {
    let link = links[i];
    let linkHref = link.getAttribute('href');

    if (linkHref && !link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
      // console.log('link updated with _blank target');
    }

    let linkDomain = new URL(linkHref, window.location.href).hostname;

    if (linkDomain !== currentDomain) {
      link.setAttribute('rel', 'nofollow');

      // console.log('link updated with nofollow rel');
    }
  }
});
